import { feedFactoryAxios } from "@feed-factory/feed-factory.helpers";

export const postMemo = (eventId: string, memo: string) => {
  return feedFactoryAxios.post(`/events/${eventId}/comments`, {
    body: memo,
  });
};
